module.exports = __webpack_public_path__ + "static/media/KSA.2d073104.png";